import RequestHelper, {ActionAnswer, Pagination} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"

export interface CategoriesCompareGet {
    id: number
    name: string
    sku_count: number
    url: string
    is_collapsed: boolean
    is_export: boolean
    categories: CategoriesCompareGet[]
    ozonCategory: { label: string, value: string },
}

export interface CategoryGet {
    fullTitle: string
    id: number
    products_count: number,
    required: { count_required_with_rules: number, count_required: number }
    collection_url: string,
    wa_categories: string[]
}

export interface PairsSet {
    wa_category_id: number
    ozon_category_id: number | undefined
}

export default class CategoriesApi {

    public static searchCategory(inputValue: string): AxiosPromise<ActionAnswer<{ category_id: string, full_name: string }[]>> {
        return RequestHelper.send("get", "categories&action=search", {
            childFree: 1,
            searchQuery: inputValue
        })
    }

    public static savePair(ozonCategoryId: number, waCategoryId: number): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("post", "categories&action=compare", {
            ozonCategory: ozonCategoryId,
            wa_category_id: waCategoryId,
        })
    }

    public static deletePairWith(waCategoryId: number): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("delete", "categories&action=compare", {
            wa_category_id: waCategoryId,
        })
    }

    public static getWaCategories(pagination: { page: number, pageCount: number, view: 'list' | 'hierarchy' }): AxiosPromise<ActionAnswer<Pagination<CategoriesCompareGet[]>>> {
        return RequestHelper.send("get", "categories&action=compare", pagination)
    }

    public static getWaAndOzonCategories(): AxiosPromise<ActionAnswer<CategoryGet[]>> {
        return RequestHelper.send("get", "categories&action=getWaAndOzonCategories")
    }

    public static getWaAndOzonCategory(category_id: number): AxiosPromise<ActionAnswer<CategoryGet>> {
        return RequestHelper.send("get", "categories&action=getWaAndOzonCategory", {category_id})
    }

    public static saveAll(data: PairsSet[]): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("post", "categories&action=saveAll", {'pairs': data})
    }
}